export enum RbacFeature {
    dashboardViewEntities = 'viewEntities',
    dashboardSearchAndFilter = 'searchAndFilter',
    dashboardDownloadData = 'exportEntities',
    dashboardUploadContract = 'uploadContract',
    dashboardUploadEntityDocument = 'uploadEntityDocument',
    dashboardAddAndEditEntity = 'createAndUpdateEntity',
    dashboardPauseEntity = 'pauseEntity',
    dashboardActivateDeactivateEntity = 'deactivateEntity',
    dashboardCreateNewLink = 'entityCreateNewLink',
    dashboardCopySubmissionLink = 'copyRequirementSubmissionLink',
    dashboardViewPendingActions = 'viewPendingActions',
    dashboardViewSubmissionHistory = 'viewSubmissionHistory',
    evieChat = 'evieChat',
    configurationActivityHistory = 'configurationActivityHistory',
    configurationApiSettings = 'configurationApiSettings',
    configurationCustomProperties = 'configurationCustomProperties',
    configurationUsersAndRoles = 'configurationUsersAndRoles',
    configurationGoAppSettings = 'configurationGoAppSettings',
    displayAndEmailBrandingSettings = 'displayAndEmailBrandingSettings',
    displayAndEmailContactInformation = 'displayAndEmailContactInformation',
    displayAndEmailContent = 'displayAndEmailContent',
    displayAndEmailSettings = 'displayAndEmailSettings',
    entityDetailsEditProperties = 'entityDetailsEditProperties',
    entityDetailsAddRemoveException = 'entityDetailsAddRemoveException',
    entityDetailsForceSubmission = 'entityDetailsForceSubmission',
    decisioningViewRiskProfiles = 'decisioningViewRiskProfiles',
    decisioningViewRiskProfile = 'decisioningViewRiskProfile',
    decisioningViewEntitiesAssigned = 'decisioningViewEntitiesAssigned',
    decisioningCreateRiskProfile = 'decisioningCreateRiskProfile',
    decisioningEditRiskProfile = 'decisioningEditRiskProfile',
    decisioningDeleteRiskProfile = 'decisioningDeleteRiskProfile',
    decisioningManageRiskRequirements = 'decisioningManageRiskRequirements',
    decisioningManageCriteria = 'decisioningManageCriteria',
    decisioningManageEvaluationRules = 'decisioningManageEvaluationRules',
    decisioningManageAssignmentRules = 'decisioningManageAssignmentRules',
    decisioningSaveRiskProfileChanges = 'decisioningSaveRiskProfileChanges',
    actionsResolveEntityAction = 'actionsResolveEntityAction',
    actionsResolveGlobalAction = 'actionsResolveGlobalAction',
    actionsViewDocument = 'actionsViewDocument',
    actionsViewMainActionsList = 'actionsViewMainActionsList',
    contractExtractionGetData = 'contractExtractionGetData',
    contractExtractionGetDocument = 'contractExtractionGetDocument',
    entityNoteGet = 'entityNoteGet',
    entityNoteCreate = 'entityNoteCreate',
}
